import { createRouter, createWebHashHistory } from "vue-router";

// チケットストア
import TicketStoreIndex from "@/views/Pages/TicketStore/TicketStoreIndex";
import OneTiemCode from "@/views/Pages/TicketStore/OneTiemCode";
import MasterBook from "@/views/Pages/TicketStore/MasterBook";
import BookBooking from "@/views/Pages/TicketStore/BookBooking";
import BookBookingPaymentSelection from "@/views/Pages/TicketStore/BookBookingPaymentSelection";
import BookBookingConfirmation from "@/views/Pages/TicketStore/BookBookingConfirmation";
import BookBookingResultProcessing from "@/views/Pages/TicketStore/BookBookingResultProcessing";
import BookBookingResult from "@/views/Pages/TicketStore/BookBookingResult";
import Survey from "@/views/Pages/TicketStore/Survey";
import ShareholderSurvey from "@/views/Pages/TicketStore/ShareholderSurvey";

// MyTicket
import MyTicketsTest from "@/views/Pages/MyTickets/MyTicketsTest";
import MyTicketsIndex from "@/views/Pages/MyTickets/MyTicketsIndex";
import MyCouponsIndex from "@/views/Pages/MyCoupons/MyCouponsIndex";
import MyCouponsIndexOfPast from "@/views/Pages/MyCoupons/MyCouponsIndexOfPast";
import MyTicketsIndexOfPast from "@/views/Pages/MyTickets/MyTicketsIndexOfPast";
import Book from "@/views/Pages/MyTickets/Book";
import BookRefund from "@/views/Pages/MyTickets/BookRefund";
import Pass from "@/views/Pages/MyTickets/Pass";
import Sheet from "@/views/Pages/MyTickets/Sheet";
import SheetValid from "@/views/Pages/MyTickets/SheetValid";
import SheetEmergencyCode from "@/views/Pages/MyTickets/SheetEmergencyCode";
import SheetMenu from "@/views/Pages/MyTickets/SheetMenu";
import StampBook from "@/views/Pages/MyTickets/StampBook";
import CouponDetailIndex from "@/views/Pages/MyCoupons/CouponDetailIndex";

// 特急券
import MfittIndex from "@/views/Pages/Mfitt/MfittIndex";
import MfittBooking1 from "@/views/Pages/Mfitt/MfittBooking1";
import MfittBooking2 from "@/views/Pages/Mfitt/MfittBooking2";
import MfittBooking3 from "@/views/Pages/Mfitt/MfittBooking3";
import MfittBooking4 from "@/views/Pages/Mfitt/MfittBooking4";
import MfittBookingConfirmation from "@/views/Pages/Mfitt/MfittBookingConfirmation";
import MfittBookingError from "@/views/Pages/Mfitt/MfittBookingError";
import MfittBookingSalesEndError from "@/views/Pages/Mfitt/MfittBookingSalesEndError";
import MfittBookingVacantSeatsError from "@/views/Pages/Mfitt/MfittBookingVacantSeatsError";
import MfittBookingMailSentError from "@/views/Pages/Mfitt/MfittBookingMailSentError";
import MfittBookingTimeoutPage from "@/views/Pages/Mfitt/MfittBookingTimeoutPage";
import MfittBookingResult from "@/views/Pages/Mfitt/MfittBookingResult";
import MfittMyTicket from "@/views/Pages/Mfitt/MfittMyTicket";
import MfittMyTicketPurchase from "@/views/Pages/Mfitt/MfittMyTicketPurchase";
import MfittMyTicketChange from "@/views/Pages/Mfitt/MfittMyTicketChange";
import MfittMyTicketRefund from "@/views/Pages/Mfitt/MfittMyTicketRefund";
import MfittMyTicketRefundConfirmation from "@/views/Pages/Mfitt/MfittMyTicketRefundConfirmation";
import MfittSelectCoupon from "@/views/Pages/Mfitt/MfittSelectCoupon";
import MfittSelectPaymentMethod from "@/views/Pages/Mfitt/MfittSelectPaymentMethod";
import MfittBookingProcessing from "@/views/Pages/Mfitt/MfittBookingProcessing";

// DBS(自転車)
import DbsBookingConfirmation from "@/views/Pages/Dbs/DbsBookingConfirmation";
import DbsIndex from "@/views/Pages/Dbs/DbsIndex";
import DbsDetail from "@/views/Pages/Dbs/DbsDetail";
import DbsMyBooking from "@/views/Pages/Dbs/DbsMyBooking";
import DbsMyUsing from "@/views/Pages/Dbs/DbsMyUsing";
import DbsMyReport from "@/views/Pages/Dbs/DbsMyReport";
import DbsSelectCycle from "@/views/Pages/Dbs/DbsSelectCycle";
import DbsUnlocking from "@/views/Pages/Dbs/DbsUnlocking";

// 周辺
import RecommendationIndex from "@/views/Pages/Recommendation/index";
import RecommendationDetail from "@/views/Pages/Recommendation/detail";

// カーシェア
import CarShareIndex from "@/views/Pages/CarShare/index";
import CarShareDetail from "@/views/Pages/CarShare/detail";

// デマンド
import DemandIndex from "@/views/Pages/Demand/index";

// Eバス
import DemandEbusBooking1 from "@/views/Pages/Demand/E-bus/booking1";
import DemandEbusBooking2 from "@/views/Pages/Demand/E-bus/booking2";
import DemandEbusBooking3 from "@/views/Pages/Demand/E-bus/booking3";
import DemandEbusBooking4 from "@/views/Pages/Demand/E-bus/booking4";
import DemandEbusConfirmation from "@/views/Pages/Demand/E-bus/confirmation";

//レンタカー
import RentalCarIndex from "@/views/Pages/RentalCar/index";
import RentalCarDetail from "@/views/Pages/RentalCar/detail";

import SetQR from "@/views/Pages/SetQR/index";
import CouponCode from "@/views/Pages/CouponCode/index";

// User
import DeleteUser from "@/views/Pages/User/delete";

const routes = [
  // indexの類は持ちません,別レポジトリ(ネイティブアプリの模倣)に設置

  // チケットストア
  // チケッチィング群
  {
    path: "/ticket-store/ticketing/index",
    name: "TicketStoreIndex",
    component: TicketStoreIndex,
  },
  {
    path: "/ticket-store/ticketing/master-book/:id/code",
    name: "OneTiemCode",
    component: OneTiemCode,
  },
  {
    path: "/ticket-store/ticketing/master-book/:id",
    name: "MasterBook",
    component: MasterBook,
  },
  {
    path: "/ticket-store/ticketing/book-booking/:id",
    name: "BookBooking",
    component: BookBooking,
  },
  {
    path: "/ticket-store/ticketing/book-booking/:id/payment_select/:book_group_id",
    name: "BookBookingPaymentSelection",
    component: BookBookingPaymentSelection,
  },
  {
    path: "/ticket-store/ticketing/book-booking/:id/confirmation/:book_group_id",
    name: "BookBookingConfirmation",
    component: BookBookingConfirmation,
  },
  {
    path: "/ticket-store/ticketing/book-booking/:id/result/:book_group_id/process/:process_id",
    name: "BookBookingResultProcessing",
    component: BookBookingResultProcessing,
  },
  {
    // ISAOからの返りURLに ?book_group_id=:id がついてくる
    path: "/ticket-store/ticketing/book-booking/:id/result/:book_group_id",
    name: "BookBookingResult",
    component: BookBookingResult,
  },
  {
    path: "/ticket-store/ticketing/:book_group_id/:master_book_id/survey/:master_survey_id",
    name: "Survey",
    component: Survey,
  },
  {
    path: "/ticket-store/ticketing/:book_group_id/:master_book_id/shareholder-survey/:master_survey_id",
    name: "ShareholderSurvey",
    component: ShareholderSurvey,
  },
  // MyTicket
  {
    path: "/my-tickets/ticketing/test",
    name: "MyTicketsTest",
    component: MyTicketsTest,
  },
  {
    path: "/my-tickets/ticketing/index",
    name: "MyTicketsIndex",
    component: MyTicketsIndex,
  },
  {
    path: "/past-tickets/index",
    name: "MyTicketsIndexOfPast",
    component: MyTicketsIndexOfPast,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id",
    name: "Book",
    component: Book,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/refund",
    name: "BookRefund",
    component: BookRefund,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/master-pass/:master_pass_id/pass/:pass_id",
    name: "Pass",
    component: Pass,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/master-sheet/:master_sheet_id/sheet/:sheet_id",
    name: "Sheet",
    component: Sheet,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/sheet/:sheet_id/valid",
    name: "SheetValid",
    component: SheetValid,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/sheet/:sheet_id/frame/:frame_id/emergency_code",
    name: "SheetEmergencyCode",
    component: SheetEmergencyCode,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/sheet/:sheet_id/menu",
    name: "SheetMenu",
    component: SheetMenu,
  },
  {
    path: "/my-tickets/ticketing/:book_group_id/stamp-book",
    name: "StampBook",
    component: StampBook,
  },
  {
    path: "/my-coupons/index",
    name: "MyCouponsIndex",
    component: MyCouponsIndex,
  },
  {
    path: "/my-coupons/coupon/:id",
    name: "CouponDetailIndex",
    component: CouponDetailIndex,
  },
  {
    path: "/past-coupons/index",
    name: "MyCouponsIndexOfPast",
    component: MyCouponsIndexOfPast,
  },
  // 特急券
  {
    path: "/mfitt/index",
    name: "MfittIndex",
    component: MfittIndex,
  },
  {
    path: "/mfitt/booking1",
    name: "MfittBooking1",
    component: MfittBooking1,
  },
  {
    path: "/mfitt/booking2",
    name: "MfittBooking2",
    component: MfittBooking2,
  },
  {
    path: "/mfitt/booking3/:id",
    name: "MfittBooking3",
    component: MfittBooking3,
  },
  {
    path: "/mfitt/booking4/:id",
    name: "MfittBooking4",
    component: MfittBooking4,
  },
  {
    path: "/mfitt/booking/:id/confirmation",
    name: "MfittBookingConfirmation",
    component: MfittBookingConfirmation,
  },
  {
    path: "/mfitt/booking/:id/error",
    name: "MfittBookingError",
    component: MfittBookingError,
  },
  {
    path: "/mfitt/booking/:id/salesend-error",
    name: "MfittBookingSalesEndError",
    component: MfittBookingSalesEndError,
  },
  {
    path: "/mfitt/booking/:id/vacantseats-error",
    name: "MfittBookingVacantSeatsError",
    component: MfittBookingVacantSeatsError,
  },
  {
    path: "/mfitt/booking/:id/mailsent-error",
    name: "MfittBookingMailSentError",
    component: MfittBookingMailSentError,
  },
  {
    path: "/mfitt/booking/:id/timeout",
    name: "MfittBookingTimeoutPage",
    component: MfittBookingTimeoutPage,
  },
  {
    path: "/mfitt/booking/:id/result",
    name: "MfittBookingResult",
    component: MfittBookingResult,
  },
  {
    path: "/mfitt/my-ticket/:id",
    name: "MfittMyTicket",
    component: MfittMyTicket,
  },
  {
    path: "/mfitt/my-ticket/:id/purchase",
    name: "MfittMyTicketPurchase",
    component: MfittMyTicketPurchase,
  },
  {
    path: "/mfitt/my-ticket/:id/change",
    name: "MfittMyTicketChange",
    component: MfittMyTicketChange,
  },
  {
    path: "/mfitt/my-ticket/:id/refund",
    name: "MfittMyTicketRefund",
    component: MfittMyTicketRefund,
  },
  {
    path: "/mfitt/my-ticket/:id/refund-confirmation",
    name: "MfittMyTicketRefundConfirmation",
    component: MfittMyTicketRefundConfirmation,
  },
  {
    path: "/mfitt/select-coupon",
    name: "MfittSelectCoupon",
    component: MfittSelectCoupon,
  },
  {
    path: "/mfitt/select-payment-method/:id",
    name: "MfittSelectPaymentMethod",
    component: MfittSelectPaymentMethod,
  },
  {
    path: "/mfitt/booking-processing/:id",
    name: "MfittBookingProcessing",
    component: MfittBookingProcessing,
  },
  // DBS
  {
    // 4, 6
    path: "/dbs/booking-confirmation",
    name: "DbsBookingConfirmation",
    component: DbsBookingConfirmation,
  },
  {
    // 1
    path: "/dbs/index",
    name: "DbsIndex",
    component: DbsIndex,
  },
  {
    // 2
    path: "/dbs/detail/:park_id",
    name: "DbsDetail",
    component: DbsDetail,
  },
  {
    // 8
    path: "/dbs/my-booking",
    name: "DbsMyBooking",
    component: DbsMyBooking,
  },
  {
    // 9
    path: "/dbs/my-using",
    name: "DbsMyUsing",
    component: DbsMyUsing,
  },
  {
    // 10
    path: "/dbs/my-report/:id",
    name: "DbsMyReport",
    component: DbsMyReport,
  },
  {
    // 3
    path: "/dbs/select-cycle/:park_id",
    name: "DbsSelectCycle",
    component: DbsSelectCycle,
  },
  {
    // 5
    path: "/dbs/unlocking",
    name: "DbsUnlocking",
    component: DbsUnlocking,
  },

  // 周辺
  {
    path: "/recommendation/index",
    name: "RecommendationIndex",
    component: RecommendationIndex,
  },
  {
    path: "/recommendation/detail/:index",
    name: "RecommendationDetail",
    component: RecommendationDetail,
  },
  // カーシェア
  {
    path: "/car-share/index",
    name: "CarShareIndex",
    component: CarShareIndex,
  },
  {
    path: "/car-share/detail/:index",
    name: "CarShareDetail",
    component: CarShareDetail,
  },
  // デマンド交通
  {
    path: "/demand/index",
    name: "DemandIndex",
    component: DemandIndex,
  },

  // Eバス
  {
    path: "/demand/E-bus/booking1",
    name: "DemandEbusBooking1",
    component: DemandEbusBooking1,
  },
  {
    path: "/demand/E-bus/booking2",
    name: "DemandEbusBooking2",
    component: DemandEbusBooking2,
  },
  {
    path: "/demand/E-bus/booking3",
    name: "DemandEbusBooking3",
    component: DemandEbusBooking3,
  },
  {
    path: "/demand/E-bus/booking4",
    name: "DemandEbusBooking4",
    component: DemandEbusBooking4,
  },
  {
    path: "/demand/E-bus/confirmation",
    name: "DemandEbusConfirmation",
    component: DemandEbusConfirmation,
  },
  // レンタカー
  {
    path: "/rental-car/index",
    name: "RentalCarIndex",
    component: RentalCarIndex,
  },
  {
    path: "/rental-car/detail/:index",
    name: "RentalCarDetail",
    component: RentalCarDetail,
  },
  // QR内容受け取りページ
  {
    path: "/setQR",
    name: "SetQR",
    component: SetQR,
  },
  {
    path: "/couponcode",
    name: "CouponCode",
    component: CouponCode,
  },

  // User
  {
    path: "/delete-user",
    name: "DeleteUser",
    component: DeleteUser,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,

  scrollBehavior() {
    return { top: 0 };
  },
});

let lastRoute = null;
router.afterEach((to, from) => {
  lastRoute = from;
});

export { router as default, lastRoute };
